import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-page-template',
  templateUrl: './page-template.component.html',
  styleUrls: ['./page-template.component.scss']
})
export class PageTemplateComponent {
  @Input() title: string = ''
  @Input() icon: string = 'dashboard'
  @Input() logo: string | undefined = undefined

  @Input() filters: boolean = false
  @Input() actions: boolean = true
  @Input() showFooter: boolean  = false
  @Input() bgBlue: boolean = false
}
